import { Permission, WhenPrint } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { PrintFacade } from 'pos/facades';

declare global {
	interface CommandType {
		changePrintMode: () => Promise<Result<WhenPrint>>
	}
}

Command.register('changePrintMode', Preconditions.ensure(Permission.Pos_ChangePrintMode), async (): Promise<Result<WhenPrint>> => {
	return Result.ok(await PrintFacade.changePrintMode());
});